import FactoryIcon from '@mui/icons-material/Factory'
import BiotechIcon from '@mui/icons-material/Biotech'
import PeopleIcon from '@mui/icons-material/People'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices'
import PublicIcon from '@mui/icons-material/Public'
import PaidIcon from '@mui/icons-material/Paid'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import BugReportIcon from '@mui/icons-material/BugReport'
import FiscaleIcon from '../svgicons/FiscaleIcon'
import { Box } from '@mui/material'
import CrmIcon from '../svgicons/CrmIcon'
import AssociativiIcon from '../svgicons/AssociativiIcon'
import AffariGeneraliIcon from '../svgicons/AffariGeneraliIcon'
import ServiziComuniIcon from '../svgicons/ServiziComuniIcon'
import PagheIcon from '../svgicons/PagheIcon'
import TecnologicaIcon from '../svgicons/TecnologicaIcon'
import VideoIcon from '../svgicons/VideoIcon'

export const ManageAccountsIconComponent = <ManageAccountsIcon fontSize="medium" color="primary" />
export const BugReportIconComponent = <BugReportIcon fontSize="medium" color="primary" />
export const AccountBalanceIconComponent = <AccountBalanceIcon fontSize="medium" color='primary' />
export const PaidIconComponent = <PaidIcon fontSize="medium" color='primary' />
export const PublicIconComponent = <PublicIcon fontSize="medium" color='primary' />
export const ShoppingCartIconComponent = <ShoppingCartIcon fontSize="medium" color='primary' />
export const MiscellaneousServicesIconComponent = <MiscellaneousServicesIcon fontSize="medium" color='primary' />
export const PeopleIconComponent = <PeopleIcon fontSize="medium" color='primary' />
export const BiotechIconComponent = <BiotechIcon fontSize="medium" color='primary' />
export const FactoryIconComponent = <FactoryIcon fontSize="medium" color='primary' />

export const FiscaleIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><FiscaleIcon /></Box>
export const CrmIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><CrmIcon /></Box>
export const AssociativiIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><AssociativiIcon /></Box>
export const AffariGeneraliIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><AffariGeneraliIcon /></Box>
export const ServiziComuniIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><ServiziComuniIcon /></Box>
export const PagheIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><PagheIcon /></Box>
export const TecnologicaIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><TecnologicaIcon /></Box>
export const VideoIconComponent = <Box sx={{ height: 24, width: 24, color: (theme) => theme.palette.primary.main}}><VideoIcon /></Box>